import { _, _any } from "i18n";
import type { Keys } from "i18n/locales/types";
import type { ProviderOperationsExecutionResponse, ProviderOperationsResultErrorKind } from "libs/apiClient";
import { formatDate } from "libs/utils";
import { PROVIDER_OPERATIONS_ACTION_LABEL_KEYS } from "./providerOperationsActionLabelKeys";

const ERROR_KIND_LABEL_KEYS: Record<ProviderOperationsResultErrorKind, string> = {
	provider: "providerOperations.result.providerError",
	internal: "providerOperations.result.internalError",
};

/** The "Provider error" badge already says this, and the provider's own response is in the raw output. */
const GENERIC_PROVIDER_FAILURE_SUMMARY = "providerOperations.action.providerFailed";

type ProviderOperationsResultCellProps = {
	latestExecution: ProviderOperationsExecutionResponse | null;
};

export function ProviderOperationsResultCell({ latestExecution }: ProviderOperationsResultCellProps) {
	if (latestExecution === null) {
		return <span className="provider-operations-muted">{_("providerOperations.result.none" as keyof Keys)}</span>;
	}

	return (
		<div className="provider-operations-result">
			<div className="provider-operations-result__summary">
				{latestExecution.resultErrorKind !== null && (
					<span
						className={`provider-operations-result__error-kind provider-operations-result__error-kind--${latestExecution.resultErrorKind}`}
					>
						{_(ERROR_KIND_LABEL_KEYS[latestExecution.resultErrorKind] as keyof Keys)}
					</span>
				)}
				{latestExecution.resultSummary !== GENERIC_PROVIDER_FAILURE_SUMMARY && (
					<span>{_any(latestExecution.resultSummary)}</span>
				)}
			</div>
			<div className="provider-operations-muted">
				{`${_(PROVIDER_OPERATIONS_ACTION_LABEL_KEYS[latestExecution.action] as keyof Keys)} · ${latestExecution.createdBy} · ${formatDate(latestExecution.createdAt)}`}
			</div>
			{latestExecution.resultRaw !== null && latestExecution.resultRaw !== "" && (
				<details className="provider-operations-result__raw">
					<summary>{_("providerOperations.result.showRawOutput" as keyof Keys)}</summary>
					<pre>{latestExecution.resultRaw}</pre>
				</details>
			)}
		</div>
	);
}
